import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import useSearchFormLogic from './useSearchFormLogic';

const StyledForm = styled.form`
  width: 100%;
`;

const SearchForm = forwardRef(({ children, className }, ref) => {
  const { handleSubmit } = useSearchFormLogic();

  return (
    <StyledForm className={className} onSubmit={handleSubmit} ref={ref}>
      {children}
    </StyledForm>
  );
});

const searchFormPropTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

const searchFormDefaultProps = {
  className: undefined,
};

SearchForm.propTypes = searchFormPropTypes;
SearchForm.defaultProps = searchFormDefaultProps;
export default SearchForm;
export { searchFormDefaultProps, searchFormPropTypes };
